module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question10.38ad5045.jpg";